function downloadAndStoreJson() {
    return $.ajax({
        url: '/user/documents/productsVariants.json?v='+new Date().getMinutes(),
        method: 'GET',
        dataType: 'json',
        success: function(data) {
            sessionStorage.setItem('productsVariants', JSON.stringify(data));
           // console.log('JSON soubor byl úspěšně stažen a uložen do sessionStorage.');
            
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error('Chyba při stahování JSON souboru:', textStatus, errorThrown);
        }
    });
}
function processProducts() {
        const productsVariants = JSON.parse(sessionStorage.getItem('productsVariants'));

        if (!productsVariants) {
            console.error('Žádná data v sessionStorage.');
            return;
        }
        $('.product').each(function() {
            const $this = $(this)
            const sku = $(this).find('[data-micro="sku"]').text().trim();
            const mainProduct = productsVariants.find(product => product.code === sku);
            if (mainProduct) {
                //console.log(`Hlavní produkt:`, mainProduct);
                const relatedProducts = productsVariants.filter(product => product.pairCode === mainProduct.pairCode);
                if (relatedProducts.length > 0) {
                    if(!$this.find('.p-bottom>div .customVar').length){
                        $this.find('.p-bottom>div').prepend('<div class="customVar"></div>')
                    }
                    relatedProducts.forEach(function(product){
                        $this.addClass('haveCustomVariant')
                        if(product.variantVisibility>0){
                            if(!$this.find('.customVar .inner[data-code="'+product.code+'"]').length){
                                if (product.stock < 1 && product.negativeAmount === 1) {
                                    productStock = 9999
                                }
                                else{
                                    productStock = product.stock
                                }
                                
                               
                                $this.find('.customVar').append('<div data-amount="1" class="inner" style="order:'+parseFloat(product.variantName)+'" data-code="'+product.code+'" data-stock="'+productStock+'"><span class="variantName">'+product.variantName+'</span><span class="¨variantPrice">'+Number(product.price).ShoptetFormatAsCurrency()+'</span></div>')
                            }
                        }
                       
                    });
                    
                } else {
                  
                   // console.log('Žádné další produkty se stejným pairCode nebyly nalezeny.');
                }
            } else {
                //console.log(`Produkt s kódem ${sku} nebyl nalezen v datech.`);
                $this.find('.p-bottom>div .prices').addClass('noVariant')
            } 
        });
}

$('html').on('click', '.customVar .inner', function(){
    $('.customInput').remove()
    $('.customVar .inner').removeClass('activeCoffe').attr('data-amount', '1')
    $(this).addClass('activeCoffe')
    $(this).closest('.p-bottom').find('.p-tools').append('<div class="customInput"><span class="customQuantity"><span class="down">-</span><input type="number" data-step="1" min="1" data-min="1" max="9999" data-max="9999" step="1" data-decimal="0" value="1"><span class="up">+</span></span><span class="button">Do košíku</span></div>')
    $('.customQuantity input').attr('data-max', $('.activeCoffe').attr('data-stock'));
    
})
$('html').on('click', '.customInput .button', function(){
    shoptet.cartShared.addToCart({productCode: $(this).closest('.p-bottom').find('.activeCoffe').data('code'), amount: $(this).closest('.p-bottom').find('.activeCoffe').attr('data-amount')});
})
    
if (sessionStorage.getItem('productsVariants')) {
    $(document).ready(function() {
        processProducts()
      })
    document.addEventListener('ShoptetDOMPageContentLoaded', function() {
        processProducts()
    });
    document.addEventListener('ShoptetPageSortingChanged', function() {
        processProducts();
    });
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
        processProducts();
    });

} else {
    downloadAndStoreJson().done(function() {
        processProducts();
    });
}

$('html').off('click', '.customQuantity .down, .customQuantity .up').on('click', '.customQuantity .down, .customQuantity .up', function() {
    var $input = $(this).closest('.customQuantity').find('input');

    var currentVal = parseFloat($input.val());
    var step = parseFloat($input.attr('data-step'));
    var max = parseFloat($input.attr('data-max'));
    var min = parseFloat($input.attr('data-min'));
    var decimals = $input.attr('data-decimals');
    var newVal;
    if ($(this).hasClass('up')) {
        newVal = (currentVal + step).toFixed(decimals);
        if (newVal > max) newVal = max;
    } else {
        newVal = (currentVal - step).toFixed(decimals);
        if (newVal < min) newVal = min;
    }
    $input.val(parseFloat(newVal).toFixed(decimals));
    $('.activeCoffe').attr('data-amount', parseFloat(newVal).toFixed(decimals));
    
})